export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Bold.2aad56b5.woff2";